import { SYMBOL_HYPHEN } from '../../../../constants/common'

export function getIsCalendarGridDayChipDragDisabled({ canMoveItems, item }) {
  const canDragItem = Boolean(canMoveItems && item.isDraggable)

  return !canDragItem
}

export function getCalendarGridDayChipDragId({ day, item }) {
  return [item.id, day].join(SYMBOL_HYPHEN)
}
